import { formatDate } from "@angular/common";

export class MarcacaoConsultaPK {

    idFilial: number = 0;

    idPaciente: number = 0;

    idPlanoSaude: number = 0;

    dataMarcacaoConsulta: Date = new Date();

    idProcedimentoConsulta: number = 0;

    constructor() {
    }

    dataMarcacaoFormatada(): string {

        let dataFormatada: string = '';

        if (this.dataMarcacaoConsulta) {

            dataFormatada = formatDate(this.dataMarcacaoConsulta, 'ddMMyyyy', 'en');
        }

        return dataFormatada;
    }
}
